import { render } from "./FAQComponent.vue?vue&type=template&id=ec6cd516"
import script from "./FAQComponent.vue?vue&type=script&lang=js"
export * from "./FAQComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__